import React from "react";
import { useHistory } from "react-router-dom";

import Button from "@/components/UI/Button";
import CardSecondary from "@/components/UI/Card/CardSecondary";
import images from "@/utils/images";

export function InstantCall({ calls }) {
  const history = useHistory();

  return calls
    .filter((call) => Object.hasOwn(call, "is_instant") && call["is_instant"])
    .map((call) => {
      const { callId, provider_name } = call;
      const queryParams = `?callId=${callId}`;

      return (
        <CardSecondary className="mt-4 d-flex d-block p-3 instant-call row mx-1" key={callId}>
          <div className="col-3 col-lg-1 mt-2">
            <img alt="Menu" className="img-fluid" src={images("./icons/call-large-green.svg")} />
          </div>

          <div className="col-9 col-lg-6 mt-2">
            <h4>
              <b>You have an incoming call from {provider_name}.</b>
            </h4>

            <p className="fs-15">
              Please click on the <b>Join Call</b> button to receive the call.
            </p>
          </div>

          <div className="p-lg-3 d-flex align-items-center col-12 col-lg-5 justify-content-end">
            <Button
              className="Btn Btn--pri"
              onClick={() =>
                history.push({
                  pathname: "/app/video-call",
                  search: queryParams,
                })
              }
            >
              Join Call
            </Button>
          </div>
        </CardSecondary>
      );
    });
}
